<template>
    <div>
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">Experimental Dataset Details</p> 
            </div>
        </div>

        <div class="tile is-ancestor">
            <div class="tile has-text-left is-12 is-vertical is-parent">
                <div class="tile is-child box">
                    <div class="columns is-mobile">
                        <div class="column is-one-quarter"><strong>Name:</strong></div>
                        <div class="column">{{currentExperimentalDataset.name}}</div>                        
                    </div>

                    <div class="columns is-mobile">
                        <div class="column is-one-quarter"><strong>Status:</strong></div>
                        <div class="column">{{currentExperimentalDataset.status}}</div>
                    </div>   

                    <div class="columns is-mobile">
                        <div class="column is-one-quarter"><strong>Experimental Plan:</strong></div>
                        <div class="column">{{currentExperimentalPlan.name}}</div>
                    </div> 

                    <div class="columns is-mobile">
                        <div class="column is-one-quarter"><strong>Created on:</strong></div>
                        <div class="column">{{moment(currentExperimentalDataset.created_at).format("DD MMMM YYYY")}}</div>
                    </div>                    
                </div>
                
                <!-- Validation Parameters Start -->
                <div class="tile is-child">
                    <p class="subtitle is-4">Validation Parameters</p>

                    <div v-for="valParam in valParamSet" :key="valParam">
                        <a class="button accordionButton is-large is-fullwidth" style="margin-top:20px" :id="valParam" v-on:click="accordionAction(valParam)">
                            <span>
                                {{valParam}}
                            </span>
                            <span class="icon is-small is-pulled-right">
                                <i class="fas fa-caret-down"></i>
                            </span>
                        </a>
                        <div class="tile is-ancestor contentOfAccordion">
                            <div class="tile is-parent">
                                <div class="tile is-child box">
                                    <div class="content">
                                        <!-- Heading of Validation Parameter -->
                                        <div class="columns is-mobile">
                                            <div class="column">
                                                <strong>Method of Assessment</strong>
                                            </div>
                                        </div>
                                        <!-- /Heading of Validation Parameter -->

                                        <!-- content of Validation Parameter -->
                                        <div v-for="assesmentMethod in assesmentMethods" :key="assesmentMethod.id"  v-if="assesmentMethod.validation_parameter_display == valParam">
                                            <hr>
                                            <div class="columns is-mobile" >
                                                <div class="column">
                                                    <!-- method of ass -->
                                                    {{assesmentMethod.name}}
                                                </div>
                                                <div class="column">
                                                    <a class="button is-primary is-small" @click="viewData(assesmentMethod)">
                                                        <span>View Data</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /content of Validation Parameter -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Validation Parameters end -->

                <div class="tile is-child">
                    <!-- Action buttons -->
                    <span v-if="currentExperimentalDataset.status != 'LOCKED'" class="is-pulled-left">
                        <a class="button is-warning is-large" @click="submitArchivedExperimentalDataset">
                            <span>Archive</span>
                        </a>
                    </span>
                    <span class="is-pulled-right">
                        <a v-if="currentExperimentalDataset.status != 'LOCKED'" class="is-primary button is-large" @click="uploadExperimentalDataset(currentExperimentalDataset)">
                            <span>Upload</span>
                        </a>                        
                        <span style="margin-left:20px"></span>
                        <a class="button is-large" @click="back">
                            <span>Back</span>
                        </a>
                    </span>
                </div>                
            </div>
        </div>
    </div>
</template>


<script>
var moment = require('moment');
export default {
    name: "ViewAnExperimentalDatasetComponent",
    props: ["currentExperimentalDataset","currentValidationPlanTemplate", "assesmentMethods", "currentExperimentalPlan", "validationParameters"],

    data: function() {
        return {
            moment:moment,
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false
        }
    },
    computed: {
        valParamSet: function(){   
            var valParamSet = new Set()    
            this.assesmentMethods.forEach(function(method) {            
                valParamSet.add(method.validation_parameter_display)
            })
            var arr = Array.from(valParamSet)
            arr.sort((a, b) => {return this.validationParameters.indexOf(a) - this.validationParameters.indexOf(b)})
            return arr
        },
    },
    methods : {
        uploadExperimentalDataset: function (currentExperimentalDataset) {
            this.$emit("uploadExperimentalDataset", currentExperimentalDataset);
        },
        back: function() {
            this.$emit("back");
        },
        viewData: function(assesmentMethod){
            this.$emit("viewData", assesmentMethod.id)            
        },
        submitArchivedExperimentalDataset: function() {
            this.$emit("submitArchivedExperimentalDataset", this.currentExperimentalDataset)
        },
        accordionAction: function(id) {
            var accordionButton = document.getElementById(id)
            var contentOfAccordion = document.getElementById(id).nextSibling
            if (contentOfAccordion.style.display == "block") {
                contentOfAccordion.style.display = "none"
                accordionButton.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            } else if(contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            }

            // accordionButton class
            var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
            otherAccordions.forEach(function(otherAccordionButton){
                if(accordionButton != otherAccordionButton){
                    var content = otherAccordionButton.nextSibling
                    content.style.display = "none"
                    otherAccordionButton.classList.remove("is-primary");
                }
                
            })

        } 
    }
}
</script>

<style scoped>
.contentOfAccordion{
    display: none;
}
</style>